import React, { useEffect, useRef, useState } from 'react';
import LeftIcon from '../../images/LeftIcon';
import {
  createDeviceTender,
  getDetailDeviceTender,
  LocationItem,
  TenderPayload,
  updateDeviceTender,
  uploadFileIcon,
} from '../../services/deviceTender.service';
import { webLoadingFalse, webLoadingTrue, webNavigate } from '../../services/navigate.service';
import {
  validateNoSpecialChars,
  validateOnlyNumbers,
  validateOnlyNumbersExpand,
} from '../../validation/ValidationInput';
import UploadIcon from '../../images/UploadIcon';
import { getLocations } from '../../services/inventoryCorrections.service';
import SearchIcon from '../../images/SearchIcon';
import DropdownIcon from '../../images/DropdownIcon';
import WhiteDropdownIcon from '../../images/WhiteDropdownIcon';
import WhiteCheckIcon from '../../images/WhiteCheckIcon';
import { showToast } from '../../services/toast.service';
import { showApiError } from '../../services/apiError';
import { coreFormLimits, limitProps, useFieldLimits, validateAgainstLimits } from '../../services/fieldLimits';
import FieldCounter from '../../components/FieldCounter';
import BackIcon from '../../images/BackIcon';
import PhotoIcon from '../../images/PhotoIcon';
import CheckIcon from '../../images/CheckIcon';
import { getPromotion } from '../../services/promotion.service';
import { useResponsive } from '../../hook/useResponsive';
interface ListCountryResponse {
  name: string;
  locationId: string;
}
interface CountryResponse {
  name: string;
  companyId: string;
  company: { companyName: string };
  id: string;
  isSelected: boolean;
  isActive: boolean;
}

const DeviceTenderDetail = () => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const userId = localStorage.getItem('userId') || '';
  const companyId = localStorage.getItem('companyId') || '';
  const preLanguage = localStorage.getItem('language');
  const [language, setLanguage] = useState<any>(null);
  const limits = useFieldLimits(coreFormLimits('device-tender'));
  const [isDragging, setIsDragging] = useState(false);
  const initalFilter = {
    searchValue: '',
  };
  const { isMobile, getWidth } = useResponsive();
  const [filter, setFilter] = useState<any>(initalFilter);
  const dropdownTenderTypeRef = useRef<HTMLDivElement>(null);
  const filterCorrectionsRef = useRef<HTMLDivElement>(null);
  const listTypeFilter = [
    { id: 1, name: 'All', value: 'All' },
    { id: 2, name: 'Checked', value: 'Checked' },
  ];
  const [isTenderTypeDropdownOpen, setIsTenderTypeDropdownOpen] = useState(false);
  const [searchTenderType, setSearchTenderType] = useState('');
  const [listCountrySelect, setListCountrySelect] = useState<LocationItem[]>([]);
  const dropdownPromotionRef = useRef<HTMLDivElement>(null);
  const [isFilterTypeDropdownOpen, setIsFilterTypeDropdownOpen] = useState(false);
  const [isPromotionDropdownOpen, setIsPromotionDropdownOpen] = useState(false);
  const [searchPromotion, setSearchPromotion] = useState('');
  const [country, setCountry] = useState<CountryResponse[]>([]);
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState<any>();
  const tenderTypes = [
    { label: 'Cash', value: 1 },
    { label: 'Card', value: 2 },
    { label: 'Promotion', value: 3 },
    { label: 'Voucher', value: 4 },
    { label: 'OnAccount', value: 5 },
  ];
  const [listPromotion, setListPromotion] = useState<any>([])
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const [filterType, setFilterType] = useState('All');
  const [formValues, setFormValues] = useState<TenderPayload>({
    tenderCode: '',
    tenderName: '',
    tenderType: 0,
    // maxPaymentRestriction: 0,
    icon: '',
    requireReference: true,
    position: 1,
    location: [
      {
        id: '',
        companyId: '',
      },
    ],
    openCashDrawer: false,
    groupOther: false,
  });
  const [step, setStep] = useState<number>(1);
  const path = window.location.pathname;
  const id: string = path.split('/').pop() || '';
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownTenderTypeRef.current &&
        !dropdownTenderTypeRef.current.contains(event.target as Node)
      ) {
        setIsTenderTypeDropdownOpen(false);
      }
      if (
        dropdownPromotionRef.current &&
        !dropdownPromotionRef.current.contains(event.target as Node)
      ) {
        setIsPromotionDropdownOpen(false);
      }
      if (
        filterCorrectionsRef.current &&
        !filterCorrectionsRef.current.contains(event.target as Node)
      ) {
        setIsFilterTypeDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.addEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(() => {
    if (window.languageContext) {
      setLanguage(window.languageContext.language);
    }
  }, [window, window.languageContext]);
  const getListPromotions = async (prmotionsId?: any) => {
    try {
      const response: any = await getPromotion({ page: 0, limit: 0 });
      setListPromotion(response?.data?.data);
      if (prmotionsId && id !== "new") {
        setSearchPromotion(response?.data?.data.find((v: any) => v.id === prmotionsId)?.promoName)
      }
    } catch (error) {
      console.error('Error loading terms:', error);
    } finally {
    }
  };
  useEffect(() => {
    if (id === 'new') {
      getListPromotions();
      getListCountry();
    }
    if (id !== 'new') {
      fetchData();
    }
    const handleNewToken = async () => {
      if (id === 'new') {
        getListCountry();
        getListPromotions();
      }
      if (id !== 'new') {
        fetchData();
      }
    };
    document.addEventListener('newToken', handleNewToken);
    return () => {
      document.removeEventListener('newToken', handleNewToken);
    };
  }, [path]);
  const handleFilterTypeSelect = (paymentName: string) => {
    setFilterType(paymentName);
    setIsFilterTypeDropdownOpen(false);
  };
  const getListCountry = async (listCountryFromProps?: ListCountryResponse[]) => {
    try {
      const response: any = await getLocations(userId, companyId, '', '', filter.searchValue);
      const listCountry: CountryResponse[] = response.data.data;
      setCountry(listCountry);
      if (id !== 'new' && listCountryFromProps && listCountryFromProps.length > 0) {
        const updatedProducts = listCountry.map((value, index) => {
          return {
            ...value,
            position: index + 1,
            isSelected: listCountryFromProps.some(val => val.locationId === value.id),
          };
        });
        setCountry(updatedProducts);
      } else {
        const dataArray = listCountry.map((val, index) => {
          return { ...val, isSelected: false, position: index + 1 };
        });
        setCountry(dataArray);
      }
    } catch (error) {
      console.error('Error loading terms:', error);
    }
  };

  const fetchData = async () => {
    webLoadingTrue();
    try {
      const response = await getDetailDeviceTender(id);
      const label = tenderTypes.filter(v => v.label === response.data.data.tenderType);
      setFormValues({
        tenderCode: response.data.data.tenderCode,
        tenderName: response.data.data.tenderName,
        tenderType: label[0].value,
        maxPaymentRestriction: response.data.data.maxPaymentRestriction,
        icon: response.data.data.icon,
        requireReference: response.data.data.requireReference,
        position: +response.data.data.position,
        promotionsId: response.data.data.promotionsId,
        location: response.data.data.deviceTenderLocationMap,
        openCashDrawer: response.data.data.openCashDrawer ?? false,
        groupOther: response.data.data.groupOther ?? false,
      });
      setSearchTenderType(response.data.data.tenderType);
      setListCountrySelect(
        response.data.data.deviceTenderLocationMap.map(
          (val: { location: { id: string }; companyId: string }) => {
            return { id: val.location.id, companyId: val.companyId };
          }
        )
      );
      const fileName = response.data.data.icon.split('/').pop();
      const rawName = fileName?.split('-').slice(5).join('-');
      setFileName(rawName);
      if (id !== 'new') {
        await getListCountry(response.data.data.deviceTenderLocationMap);
        await getListPromotions(response.data.data.promotionsId);
      }
    } catch (error) {
      console.error('Error loading terms:', error);
    } finally {
      webLoadingFalse();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleSelectTenderType = (tender: { label: string; value: number }) => {
    setFormValues({ ...formValues, tenderType: tender.value });
    setSearchTenderType(tender.label);
    setIsTenderTypeDropdownOpen(false);
  };
  const handleSelectPromotion = (promotion: { promoName: string; id: string }) => {
    setFormValues({ ...formValues, promotionsId: promotion.id });
    setSearchPromotion(promotion.promoName);
    setIsPromotionDropdownOpen(false);
  };
  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result;
        setFile(file);
        setFileName(file.name);
      };
      reader.readAsDataURL(file);
    } else {
      alert('Please upload an image file.');
    }
  };
  const handleSubmitSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const updatedFilter = { ...filter };
      getListCountry(updatedFilter.searchValue);
    }
  };
  const handleDrop = (e: any) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64 = reader.result as string;
        setFileName(file.name);
        setFile(file);
        // setBase64Image(base64);
      };

      reader.readAsDataURL(file);
    } else {
      alert('Please upload a valid image file.');
    }
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleSelectCompany = (index: number) => {
    const updatedProducts = [...country];
    const selectedLocation = updatedProducts[index];
    selectedLocation.isSelected = !selectedLocation.isSelected;
    const exists = listCountrySelect.some(attr => attr.id === selectedLocation.id);
    const updatedAttributes = exists
      ? listCountrySelect.filter(attr => attr.id !== selectedLocation.id)
      : [
        ...listCountrySelect,
        {
          id: selectedLocation.id,
          companyId: selectedLocation.companyId,
        },
      ];
    setCountry(updatedProducts);
    setListCountrySelect(updatedAttributes);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors: any = validateAgainstLimits(formValues as any, limits, language, [
      'tenderCode',
      'tenderName',
      'tenderType',
      'maxPaymentRestriction',
    ]);
    if (!formValues.tenderType) {
      newErrors.tenderType = 'Tender Type is required';
    }
    if (!formValues.tenderName) {
      newErrors.tenderName = 'Tender Name is required';
    }
    if (!formValues.tenderCode) {
      newErrors.tenderCode = 'Tender Code is required';
    }
    if (formValues?.tenderType === 3 && !formValues?.promotionsId) {
      newErrors.promotionsId = 'Promotion is required';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setStep(1);
      return;
    }
    webLoadingTrue();
    let iconUrl = formValues.icon;
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await uploadFileIcon(formData);
        iconUrl = response.data.data;
      } catch (error) {
        console.error('Upload file failed:', error);
        showApiError(error, { language });
      }
    }
    const payload: TenderPayload = {
      ...formValues,
      icon: iconUrl,
      location: listCountrySelect,
      maxPaymentRestriction: formValues?.maxPaymentRestriction
        ? +formValues?.maxPaymentRestriction
        : 0,
      position: formValues?.position ? +formValues?.position : 1,
    };
    if (id === 'new') {
      try {
        const response: any = await createDeviceTender(payload);
        if (response) {
          webNavigate('/' + preLanguage + '/deviceTender');
          webLoadingFalse();
          showToast({
            message: 'Device Tender Created !',
            type: 'success',
            duration: 20000,
          });
        }
      } catch (error: any) {
        webLoadingFalse();
        webNavigate('/' + preLanguage + '/deviceTender');
        showApiError(error, { language });
      }
    } else {
      try {
        const response: any = await updateDeviceTender(id, payload);
        if (response) {
          webNavigate('/' + preLanguage + '/deviceTender');
          webLoadingFalse();
          showToast({
            message: language?.['Device Tender Updated !'] ?? 'Device Tender Updated !',
            type: 'success',
            duration: 20000,
          });
        }
      } catch (error: any) {
        webLoadingFalse();
        webNavigate('/' + preLanguage + '/deviceTender');
        showApiError(error, { language });
      }
    }
  };
  return (
    <>
      <div className="bg-white">
        <div className="flex items-center ">
          <div
            className="w-6 h-6 flex items-center justify-center cursor-pointer"
            onClick={() => {
              webNavigate('/' + preLanguage + '/deviceTender');
            }}
          >
            <BackIcon />
          </div>
          <p
            style={{ fontSize: '14px', fontWeight: '500', lineHeight: '28px', color: '#222525' }}
            className="font-inter"
          >
            {language && language?.['Back'] ? language?.['Back'] : 'Back'}
          </p>
        </div>
      </div>
      {id === 'new' ? (
        <p
          style={{
            margin: '20px 0px',
            fontSize: '20px',
            fontWeight: '500',
            lineHeight: '28px',
            color: '#222525',
          }}
          className="font-inter"
        >
          {language && language?.['Add Device Tender']
            ? language?.['Add Device Tender']
            : 'Add Device Tender'}
        </p>
      ) : (
        <p
          style={{
            margin: '20px 0px',
            fontSize: '20px',
            fontWeight: '500',
            lineHeight: '28px',
            color: '#222525',
          }}
          className="font-inter"
        >
          {language && language?.['Edit Device Tender']
            ? language?.['Edit Device Tender']
            : 'Edit Device Tender'}
        </p>
      )}
      <div className="flex items-start lg:items-center" style={{ gap: isMobile ? '10px' : '20px', marginTop: isMobile ? '2px' : '0', marginBottom: '24px', display: 'none' }}>
        <div
          className=""
          style={{
            width: isMobile ? 'calc(50% - 5px)' : 'calc(50% - 10px)',
          }}
        >
          <div
            className="w-full"
            style={{
              minHeight: '4px',
              width: "100%",
              backgroundColor: step === 1 || step === 2 ? '#0F7679' : '#DBE4E4',
              borderRadius: '20px',
            }}
          ></div>
          <div className="" style={{ marginTop: isMobile ? "6px" : "12px" }}>
            <div className="flex items-center" style={{ gap: '8px' }}>
              {step === 2 && (
                <div
                  className="flex items-center justify-center"
                  style={{ width: '20px', height: '20px' }}
                >
                  <CheckIcon />
                </div>
              )}
              <p
                className="font-medium text-[14px] font-inter leading-[20px]"
                style={{ color: '#0F7679' }}
              >
                {language && language?.['Step 1'] ? language?.['Step 1'] : 'Step 1'}
              </p>
            </div>
            <p
              className="font-medium text-[14px] font-inter leading-[20px]"
              style={{ color: '#05292A' }}
            >
              {language && language?.['Details'] ? language?.['Details'] : 'Details'}
            </p>
          </div>
        </div>
        <div
          className=""
          style={{
            width: isMobile ? 'calc(50% - 5px)' : 'calc(50% - 10px)',
          }}
        >
          <div
            className=""
            style={{
              minHeight: '4px',
              width: "100%",
              backgroundColor: step === 2 ? '#0F7679' : '#DBE4E4',
              borderRadius: '20px',
            }}
          ></div>
          <div className="" style={{ marginTop: isMobile ? "6px" : "12px" }}>
            <div className="flex items-center">
              <p
                className="font-medium text-[14px] font-inter leading-[20px]"
                style={{ color: '#0F7679' }}
              >
                {language && language?.['Step 2'] ? language?.['Step 2'] : 'Step 2'}
              </p>
            </div>
            <p
              className="font-medium text-[14px] font-inter leading-[20px]"
              style={{ color: '#05292A' }}
            >
              {language && language?.['Select Products'] ? language?.['Select Products'] : 'Select Products'}
            </p>
          </div>
        </div>
      </div>
      <div
        className="scroll-container"
        style={{ height: isMobile ? 'calc(100% - 147px)' : 'calc(100% - 187px)', overflowY: 'scroll', paddingBottom: isMobile ? '16px' : '' }}
      >
        {(
          <form onSubmit={handleSubmit}>
            <div
              className="rounded-md bg-white flex items-start"
              style={{ flexWrap: 'wrap', gap: 24 }}
            >
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Type'] ? language?.['Type'] : 'Type'}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#BA0E13' }}
                  >
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <div className="relative" ref={dropdownTenderTypeRef}>
                    <input
                      tabIndex={1}
                      type="text"
                      value={searchTenderType}
                      onKeyDown={validateNoSpecialChars}
                      style={{ pointerEvents: 'all', width: '100%' }}
                      onChange={e => {
                        setSearchTenderType(e.target.value);
                        setIsTenderTypeDropdownOpen(true);
                      }}
                      onClick={() => setIsTenderTypeDropdownOpen(true)}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-input border border-[#DBE4E4] px-2 py-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                    {isTenderTypeDropdownOpen && (
                      <div
                        className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend"
                        style={{ width: '180px' }}
                      >
                        {tenderTypes.map((tender: { label: string; value: number }) => (
                          <div
                            key={tender?.value}
                            style={{ padding: '8px 6px', borderRadius: '4px' }}
                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                            onClick={() => handleSelectTenderType(tender)}
                          >
                            {tender?.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {errors.tenderType && <p className="error">{errors.tenderType}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Code'] ? language?.['Code'] : 'Code'}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#BA0E13' }}
                  >
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={2}
                    type="text"
                    name="tenderCode"
                    {...limitProps(limits, 'tenderCode')}
                    value={formValues.tenderCode}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.tenderCode} max={limits.tenderCode?.maxLength} />
                </div>
                {errors.tenderCode && <p className="error">{errors.tenderCode}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Name'] ? language?.['Name'] : 'Name'}
                  </p>
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#BA0E13' }}
                  >
                    {language && language?.['*'] ? language?.['*'] : '*'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={3}
                    type="text"
                    name="tenderName"
                    {...limitProps(limits, 'tenderName')}
                    value={formValues.tenderName}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                  <FieldCounter value={formValues.tenderName} max={limits.tenderName?.maxLength} />
                </div>
                {errors.tenderName && <p className="error">{errors.tenderName}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Maximum accepted amount']
                      ? language?.['Maximum accepted amount']
                      : 'Maximum accepted amount'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={4}
                    type="text"
                    name="maxPaymentRestriction"
                    value={formValues.maxPaymentRestriction}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    onKeyDown={validateOnlyNumbersExpand}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.maxPaymentRestriction && (
                  <p className="error">{errors.maxPaymentRestriction}</p>
                )}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Position'] ? language?.['Position'] : 'Position'}
                  </p>
                </div>
                <div className="w-full">
                  <input
                    tabIndex={5}
                    type="text"
                    name="position"
                    value={formValues.position}
                    onChange={(e: any) => {
                      handleChange(e);
                    }}
                    className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                  />
                </div>
                {errors.position && <p className="error">{errors.maxPaymentRestriction}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Promotion'] ? language?.['Promotion'] : 'Promotion'}
                  </p>
                </div>
                <div className="w-full">
                  <div className="relative" ref={dropdownPromotionRef}>
                    <input
                      tabIndex={6}
                      type="text"
                      value={searchPromotion}
                      onKeyDown={validateNoSpecialChars}
                      style={{ pointerEvents: 'all', width: '100%' }}
                      onChange={e => {
                        setSearchPromotion(e.target.value);
                        setIsPromotionDropdownOpen(true);
                      }}
                      onClick={() => setIsPromotionDropdownOpen(true)}
                      className={`text-[14px] font-inter placeholder:text-placeholder text-main border border-[#EBEBED] p-3 rounded-xl  outline-none focus-none bg-transparent w-full`}
                    />
                    {isPromotionDropdownOpen && (
                      <div
                        className="absolute z-10 mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend"
                        style={{ width: '180px' }}
                      >
                        {listPromotion.map((promotion: { promoName: string; id: string }) => (
                          <div
                            key={promotion?.id}
                            style={{ padding: '8px 6px', borderRadius: '4px' }}
                            className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-inter duration-300"
                            onClick={() => handleSelectPromotion(promotion)}
                          >
                            {promotion?.promoName}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                {errors.promotionId && <p className="error">{errors.promotionId}</p>}
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Open cash drawer']
                      ? language?.['Open cash drawer']
                      : 'Open cash drawer'}
                  </p>
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="openCashDrawer"
                    checked={formValues.openCashDrawer ?? false}
                    onChange={(e) =>
                      setFormValues({ ...formValues, openCashDrawer: e.target.checked })
                    }
                    className="w-4 h-4 rounded border-[#DBE4E4] text-[#0F7679] focus:ring-[#0F7679]"
                  />
                </div>
              </div>
              <div className="space-y-2" style={{ width: isMobile ? '100%' : 'calc(33% - 12px)' }}>
                <div className="flex items-center justify-between">
                  <p
                    className="text-[14px] font-inter leading-[20px] font-medium"
                    style={{ color: '#4A5353' }}
                  >
                    {language && language?.['Group under Other']
                      ? language?.['Group under Other']
                      : 'Group under Other'}
                  </p>
                </div>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="groupOther"
                    checked={formValues.groupOther ?? false}
                    onChange={(e) =>
                      setFormValues({ ...formValues, groupOther: e.target.checked })
                    }
                    className="w-4 h-4 rounded border-[#DBE4E4] text-[#0F7679] focus:ring-[#0F7679]"
                  />
                </div>
              </div>
              <div className="space-y-2" style={{ width: '100%' }}>
                <p
                  className="text-[14px] font-inter leading-[20px] font-medium"
                  style={{ color: '#4A5353' }}
                >
                  {language && language?.['Device tender icon']
                    ? language?.['Device tender icon']
                    : 'Device tender icon'}
                </p>
                <div className="lg:flex items-start space-y-2" style={{ gap: 16, marginTop: '12px' }}>
                  <div
                    className="flex items-center justify-center rounded-full"
                    style={{
                      width: '84px',
                      height: '84px',
                      backgroundColor: '#EBF0F0',
                      border: '1px solid #EBF0F0',
                    }}
                  >
                    <PhotoIcon />
                  </div>
                  <div
                    className="w-full flex items-center justify-center"
                    style={{
                      backgroundColor: '#FCFDFD',
                      padding: '20px',
                      border: `1px dashed ${isDragging ? '#3AC0C4' : '#DBE4E4'}`,
                      borderRadius: '16px',
                      flex: 1,
                    }}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                  >
                    <div className="text-center space-y-2">
                      <div className="flex items-center justify-center">
                        <UploadIcon />
                      </div>
                      <p
                        style={{ color: '#222525', marginTop: '12px' }}
                        className="text-[14px] leading-[20px] font-inter"
                      >
                        {fileName
                          ? `File: ${fileName}`
                          : language && language?.['Drag and drop your icon here']
                            ? language?.['Drag and drop your icon here']
                            : 'Drag and drop your icon here'}
                      </p>
                      <p
                        style={{ fontSize: '12px', color: '#819596', margin: '12px 0' }}
                        className="font-inter"
                      >
                        {language && language?.['OR'] ? language?.['OR'] : 'OR'}
                      </p>
                      <label
                        htmlFor="fileInput"
                        className="text-[14px] font-inter font-semibold leading-[18px] cursor-pointer font-inter"
                        style={{
                          borderRadius: '30px',
                          color: '#0F7679',
                          padding: '8px 16px',
                          border: '1px solid #C9D7D8',
                        }}
                      >
                        {language && language?.['Browse file']
                          ? language?.['Browse file']
                          : 'Browse file'}
                      </label>
                      <input
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="fileInput"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
      <div
        className="w-full flex items-center justify-end shadow_button relative"
        style={{ gap: "12px", paddingTop: "24px", }}
      >
        <div className="absolute" style={{ left: "-24px", top: 0, height: "1px", backgroundColor: "#DBE4E4", width: isMobile ? 'calc(100vw + 32px)' : "calc(-256px + 48px + 100vw)" }}></div>
        <div
          onClick={() => webNavigate('/' + preLanguage + '/deviceTender')}
          style={{
            padding: '10px 24px',
            borderRadius: '30px',
            color: '#222525',
            fontSize: '14px',
            fontWeight: '500',
            border: '1px solid #C9D7D8',
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.['Cancel'] ? language?.['Cancel'] : 'Cancel'}
        </div>
        <div
          onClick={(e: any) => {
            handleSubmit(e);
          }}
          style={{
            padding: '10px 24px',
            borderRadius: '30px',
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: '500',
            backgroundColor: '#0F7679',
          }}
          className="font-inter cursor-pointer"
        >
          {language && language?.['Save'] ? language?.['Save'] : 'Save'}
        </div>
      </div>
    </>
  );
};
export default DeviceTenderDetail;
